import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { useSingleBarGraphOption } from "./options"

type useSingleBarGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useSingleBarGraphOption<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useSingleBarGraphEvents = <T,>({
	graphOption: {
		axisDef
	},
	onChangeCondition
}: useSingleBarGraphEventsProps<T>) => {
  const onClickGraph = useCallback(
    (params?: {
      event?: { event?: { ctrlKey?: boolean } }
      seriesId?: string
      seriesName?: string
    }) => {
      if (!axisDef?.key || !params?.seriesId || !params?.seriesName) return
      const ctrlKey = params?.event?.event?.ctrlKey ? true : false
      onChangeCondition(
        axisDef.key,
        { code: [params.seriesId], label: params.seriesName },
        ctrlKey
      )
    },
    [axisDef, onChangeCondition]
  )
	return {
		click: onClickGraph
	}
}